import { ArrowLeftOutlined } from "@ant-design/icons"
import { Button } from "antd"
import React from "react"
import { Link } from "react-router-dom"

import { RoutesPaths } from "../../../../constants/routes.ts"

interface DocumentBackToLeadBtnProps {
  leadId: string
  saving: boolean
}

export function DocumentBackToLeadBtn({
  leadId,
  saving
}: DocumentBackToLeadBtnProps) {
  return (
    <Link
      className={saving ? "pointer-events-none" : ""}
      to={RoutesPaths.lead.view(leadId)}
    >
      <Button disabled={saving} icon={<ArrowLeftOutlined />}>
        Back to Lead
      </Button>
    </Link>
  )
}
